import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useParams } from 'react-router-dom';
import { $inquiryStore } from '@lib/store';
import { cn } from '@shared/utils';
import { Documents, TotalCost, TravelDetails, TravelHeader } from './widgets';
import { View } from '@widgets';

export const TravelMyRequestPage = () => {
  const { id } = useParams<{ id: string }>();

  const inquiryStore = useUnit($inquiryStore.store);

  useEffect(() => {
    if (!id) return;
    $inquiryStore.events.getInquiry({ inquiryId: id });
    return () => $inquiryStore.events.clear();
  }, [id]);

  return (
    <View
      loading={inquiryStore.loading}
      noData={!inquiryStore.data}
      error={inquiryStore.error}
      onRefresh={() => $inquiryStore.events.getInquiry({ inquiryId: id! })}
    >
      {inquiryStore.data && (
        <>
          <TravelHeader inquiry={inquiryStore.data} />
          <section className={cn('flex flex-auto gap-6', 'max-xl:flex-col')}>
            <TravelDetails className={cn('min-w-0 basis-2/3', 'max-xl:basis-auto')} inquiry={inquiryStore.data} />
            <div className={cn('flex basis-1/3 flex-col gap-6', 'max-xl:basis-auto')}>
              <TotalCost inquiry={inquiryStore.data} />
              <Documents inquiry={inquiryStore.data} />
            </div>
          </section>
        </>
      )}
    </View>
  );
};
